import { connect } from 'react-redux'
import { reset, getFormValues } from 'redux-form'
import {
  GET_REFERRALOUTCOME_LIST,
  GET_BOPINSTITUTIONS_LIST,
  GET_DRUGAFTERCAREPROGRAMS_LIST,
  GET_GANGAFFILIATIONS_LIST,
  GET_REFERRALSOURCE_LIST,
                                                                  // GET_BHTsINSURANCEPROVIDERS_LIST
} from '../actions/action-constants'
import { getDropDownsList } from '../actions/actions-drop-downs'
import { getProgramsAssignedToLoginList } from '../actions/actions-programs'
import { createNewReferral, addReferral } from '../actions/actions-referrals'
import ReferralAddRoot from '../components/add-edit-view-referral/referral-container-root-add'
const mapStateToProps = (state, ownProps) => {
  return {
    parentProps: ownProps,
    initialValues: state.referralsR.dataEntry,
    currentFormState: getFormValues('ReferralEditForm')(state),
    programsList: state.programsR.programsassignedtologin,
    referralOutcomesList: state.referraloutcomesR,
                                                                // bhtsinsuranceprovidersList: state.bhtsinsuranceprovidersR,
    // bopinstitutionsList: state.bopinstitutionsR,
    // gangaffiliationsList: state.gangaffiliationsR,
    // referralsourcesList: state.referralsourcesR,
    bopinstitutionsList: state.bopinstitutionsR.bopinstitutions,
    gangaffiliationsList: state.gangaffiliationsR.gangaffiliations,
    referralsourcesList: state.referralsourcesR.referralsources,
    loadingList: state.referralsR.loadingList,
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    addReferral: referralEntry => {
      dispatch(addReferral(referralEntry))
        .then(() => dispatch(reset('ReferralEditForm')))
        .then(() => ownProps.history.push('/referrals'))
    },

    createNewReferral: () => {
      dispatch(createNewReferral())
    },

    getPrograms: (loginid) => {
      dispatch(getProgramsAssignedToLoginList(loginid))
    },
    getReferralOutcomes: params => {
      dispatch(getDropDownsList(params, GET_REFERRALOUTCOME_LIST))
    },
                                                  // getBHTsInsuranceProviders: params => {
                                                  //   dispatch(getDropDownsList(params, GET_BHTsINSURANCEPROVIDERS_LIST))
                                                  // },
    getBOPInstitutions: params => {
      dispatch(getDropDownsList(params, GET_BOPINSTITUTIONS_LIST))
    },
    getDrugAftercarePrograms: params => {
      dispatch(getDropDownsList(params, GET_DRUGAFTERCAREPROGRAMS_LIST))
    },
    getGangAffiliations: params => {
      dispatch(getDropDownsList(params, GET_GANGAFFILIATIONS_LIST))
    },
    getReferralSources: params => {
      dispatch(getDropDownsList(params, GET_REFERRALSOURCE_LIST))
    }
  }
}
const ReferralAddContainer = connect(mapStateToProps, mapDispatchToProps)(ReferralAddRoot)
export default ReferralAddContainer
